import React, { useEffect, useState } from "react";
import { ChevronUpIcon } from "@heroicons/react/24/outline";

const BackToTopButton: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-50 bg-black hover:bg-neutral-900 text-white rounded-lg shadow-lg p-3 w-10 h-10 flex items-center justify-center transition-colors duration-200 focus:outline-none ring-1 ring-white"
    >
      <ChevronUpIcon className="w-5 h-5" />
    </button>
  );
};

export default BackToTopButton;
